module.exports = __webpack_public_path__ + "static/media/map airport icon.b0cfddb2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/route-finder/map airport icon.svg
// module id = 850
// module chunks = 0